import { BaseTeethArchDropdown, CapturePosition, NavBarAction, Split } from '../../../../../common';
import { PathLevels, TeethArchPosition } from '../../../../../models';
import { useBoundStore } from '../../../../../surgeries/stores/useStore';
import { useOrthBoundStore } from '../../../../stores/useStore';

import { useTranslation } from 'react-i18next';
import ReactTooltip from 'react-tooltip';

import LowerTheethArch from '../../../../../assets/icons/jaw-down.svg';
import OpenJaws from '../../../../../assets/icons/jaw-open.svg';
import UpperTheethArch from '../../../../../assets/icons/jaw-top.svg';
import BothTheethArch from '../../../../../assets/icons/jaws.svg';

import { useCallback, useMemo, useState } from 'react';
import { useWindowSize } from '../../../../../hooks';
import { Constants } from '../../../../../shared';

import { useLocation } from 'react-router-dom';
import { CommonPagesUrl } from '../../../../../AppRouter';
import './orthoteetharch.scss';

const showEvergineArches = (archToShow: CapturePosition) => {
  window.App.webEventsProxy.layers.showArches(archToShow);
};

const changeVisibleCapture: { [key: string]: (isUpperVisible?: boolean, isLowerVisible?: boolean) => void } = {
  [TeethArchPosition.UPPER]: (/* isUpperVisible: boolean */) => {
    /* const archToShow = isUpperVisible ? CapturePosition.UPPER : CapturePosition.LOWER;
    showEvergineArches(CapturePosition.NONE);
    showEvergineArches(archToShow); */
    showEvergineArches(CapturePosition.UPPER);
  },
  [TeethArchPosition.LOWER]: (/* _, isLowerVisible: boolean */) => {
    /* const archToShow = isLowerVisible ? CapturePosition.LOWER : CapturePosition.UPPER;
    showEvergineArches(CapturePosition.NONE);
    showEvergineArches(archToShow); */
    showEvergineArches(CapturePosition.LOWER);
  },
  [TeethArchPosition.BOTH]: () => {
    showEvergineArches(CapturePosition.BOTH);
  },
  [TeethArchPosition.BOTH_OPEN]: () => {
    showEvergineArches(CapturePosition.BOTH_OPEN);
  }
};

export const OrthoTeethArch = (actionProps: any) => {
  const {
    orthTeethArch,
    setOrthTeethArch,
    showUpperArch,
    setShowUpperArch,
    showLowerArch,
    setShowLowerArch,
    setShowMiniOcclusogram
  } = useOrthBoundStore();
  const { setSplitMode } = useBoundStore();
  const [currentBothArchSelected, setCurrentBothArchSelected] = useState(TeethArchPosition.BOTH);
  const size = useWindowSize();
  const { pathname } = useLocation();
  const shortedPathName = useMemo(() => `/${pathname.split('/')[PathLevels.RouteView]}`, [pathname]);
  const [t] = useTranslation();

  const options = [
    { translationKey: 'upper', type: TeethArchPosition.UPPER },
    { translationKey: 'lower', type: TeethArchPosition.LOWER },
    { translationKey: 'both', type: TeethArchPosition.BOTH },
    { translationKey: 'open', type: TeethArchPosition.BOTH_OPEN }
  ];

  const onSelectTeeth = useCallback(
    (option: TeethArchPosition) => {
      const isBoth = option === TeethArchPosition.BOTH || option === TeethArchPosition.BOTH_OPEN;
      /* const isUpperVisible = isBoth ? true : option === TeethArchPosition.UPPER ? !showUpperArch : showUpperArch;
      const isLowerVisible = isBoth ? true : option === TeethArchPosition.LOWER ? !showLowerArch : showLowerArch; */
      const isUpperVisible = isBoth ? true : option === TeethArchPosition.UPPER ? showUpperArch : false;
      const isLowerVisible = isBoth ? true : option === TeethArchPosition.LOWER ? showLowerArch : false;
      const isBothArchVisible = isUpperVisible && isLowerVisible;
      const archToShow = isBoth ? option : isBothArchVisible ? currentBothArchSelected : option;

      changeVisibleCapture[archToShow](isUpperVisible, isLowerVisible);

      setShowUpperArch(isBoth || option === TeethArchPosition.UPPER);
      setShowLowerArch(isBoth || option === TeethArchPosition.LOWER);
      setOrthTeethArch(option);

      if (isBoth) {
        setCurrentBothArchSelected(option);
      }

      if (actionProps.block.changeSplitMode) {
        setSplitMode(isBoth ? Split.Split2 : Split.Single);
      }

      if (option === TeethArchPosition.BOTH_OPEN) {
        setShowMiniOcclusogram(false);
      }
    },
    [showLowerArch, setShowLowerArch, showUpperArch, setShowUpperArch, currentBothArchSelected]
  );

  const getItemsOnARow = () => (
    <>
      <NavBarAction
        icon={UpperTheethArch}
        dataFor="archViewUpper"
        disabled={shortedPathName === CommonPagesUrl.StlCaptures}
        altText={t('navbar.actions.maxilla.upper')}
        action={() => onSelectTeeth(TeethArchPosition.UPPER)}
        isEndOfBlock={actionProps?.block?.isEndOfBlock}
      />
      <ReactTooltip id="archViewUpper" place="bottom" effect="solid" className="tooltip" type="dark">
        {t('navbar.actions.maxilla.upper')}
      </ReactTooltip>
      <NavBarAction
        icon={LowerTheethArch}
        dataFor="archViewLower"
        disabled={shortedPathName === CommonPagesUrl.StlCaptures}
        altText={t('navbar.actions.maxilla.lower')}
        action={() => onSelectTeeth(TeethArchPosition.LOWER)}
        isEndOfBlock={actionProps?.block?.isEndOfBlock}
      />
      <ReactTooltip id="archViewLower" place="bottom" effect="solid" className="tooltip" type="dark">
        {t('navbar.actions.maxilla.lower')}
      </ReactTooltip>
      <NavBarAction
        icon={BothTheethArch}
        dataFor="archViewBoth"
        disabled={shortedPathName === CommonPagesUrl.StlCaptures}
        altText={t('navbar.actions.maxilla.both')}
        action={() => onSelectTeeth(TeethArchPosition.BOTH)}
        isEndOfBlock={actionProps?.block?.isEndOfBlock}
      />
      <ReactTooltip id="archViewBoth" place="bottom" effect="solid" className="tooltip" type="dark">
        {t('navbar.actions.maxilla.both')}
      </ReactTooltip>
      <NavBarAction
        icon={OpenJaws}
        dataFor="archViewBothOpen"
        disabled={shortedPathName === CommonPagesUrl.StlCaptures}
        altText={t('navbar.actions.maxilla.open')}
        action={() => onSelectTeeth(TeethArchPosition.BOTH_OPEN)}
        isEndOfBlock={actionProps?.block?.isEndOfBlock}
      />
      <ReactTooltip id="archViewBothOpen" place="bottom" effect="solid" className="tooltip" type="dark">
        {t('navbar.actions.maxilla.open')}
      </ReactTooltip>
    </>
  );

  return size.width <= Constants.widthMSizePixels ? (
    <BaseTeethArchDropdown
      dropdownOptions={options}
      handleSelectOption={(option: TeethArchPosition) => onSelectTeeth(option)}
      defaultType={orthTeethArch || TeethArchPosition.BOTH}
    />
  ) : (
    getItemsOnARow()
  );
};
